// SPDX-License-Identifier: GPL-3.0-or-later

// Side-effect слой: getUserMedia, включение/выключение микрофона и отдача потока наружу.
// ViewModel работает только с этим интерфейсом, что позволяет подменять реализацию в тестах.

export interface MediaService {
  acquire(): Promise<MediaStream>;
  getStream(): MediaStream | null;
  setMuted(muted: boolean): void;
  isMuted(): boolean;
  release(): void;
}

export class BrowserMediaService implements MediaService {
  private stream: MediaStream | null = null;
  private muted = false;

  async acquire(): Promise<MediaStream> {
    if (this.stream) return this.stream;
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
      video: false,
    });
    this.stream = stream;
    this.applyMuted();
    return stream;
  }

  getStream(): MediaStream | null {
    return this.stream;
  }

  setMuted(muted: boolean): void {
    this.muted = muted;
    this.applyMuted();
  }

  isMuted(): boolean {
    return this.muted;
  }

  release(): void {
    if (!this.stream) return;
    for (const track of this.stream.getTracks()) track.stop();
    this.stream = null;
  }

  private applyMuted(): void {
    if (!this.stream) return;
    for (const track of this.stream.getAudioTracks()) track.enabled = !this.muted;
  }
}
